import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Typography from '@repo/ui/typography'
import { useEffect } from 'react'

import withTheme from '../../components/hoc/with-theme'
import AuthLayout from '../../components/layouts/auth-layout'
import { SsoLoginForm } from '../../components/pages/login/sso-login-form'

export const ServiceProviderLoginPage = () => {
  useEffect(() => {
    document.querySelector('html')?.setAttribute('data-theme', 'ol')
  }, [])

  return (
    <AuthLayout text={`Welcome to Your Personal\nProvider Area.`}>
      <Typography variant={'h1'} className="mb-4" color={tailwindColors.black.DEFAULT}>
        Sign in
      </Typography>
      <SsoLoginForm />
    </AuthLayout>
  )
}

export default withTheme(ServiceProviderLoginPage, 'ol')
